import React from 'react';
import { Form } from 'react-bootstrap';
import type { CabRiscosLayout } from '../cabPresentationTemplates';

type Props = {
  layout: CabRiscosLayout;
  canManage: boolean;
  onChange: (next: CabRiscosLayout) => void;
};

const CabDeckRiscosEditor: React.FC<Props> = ({ layout, canManage, onChange }) => {
  return (
    <div className="mb-3">
      <h3 className="h6">Linhas de riscos</h3>
      {layout.rows.map((row, rowIndex) => (
        <div key={`risco-row-${rowIndex}`} className="border rounded p-2 mb-2">
          <div className="small text-muted mb-1">Linha {rowIndex + 1}</div>
          <Form.Control
            className="mb-1"
            size="sm"
            placeholder="Risco"
            disabled={!canManage}
            value={row.risco}
            onChange={(e) => {
              const rows = layout.rows.map((r, i) =>
                i === rowIndex ? { ...r, risco: e.target.value } : r,
              );
              onChange({ ...layout, rows });
            }}
          />
          <Form.Control
            className="mb-1"
            size="sm"
            placeholder="Status"
            disabled={!canManage}
            value={row.status}
            onChange={(e) => {
              const rows = layout.rows.map((r, i) =>
                i === rowIndex ? { ...r, status: e.target.value } : r,
              );
              onChange({ ...layout, rows });
            }}
          />
          <Form.Control
            size="sm"
            as="textarea"
            rows={2}
            placeholder="Comentários"
            disabled={!canManage}
            value={row.comentarios}
            onChange={(e) => {
              const rows = layout.rows.map((r, i) =>
                i === rowIndex ? { ...r, comentarios: e.target.value } : r,
              );
              onChange({ ...layout, rows });
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default CabDeckRiscosEditor;
